import React, { Component } from 'react';
import '../../App.css';

import Footer from '../reusables/footer'

import logo from '../../img/corpo.jpg'
import fruit from '../../img/fruit.png'
import fish from '../../img/fish.png'
import roses from '../../img/roses.png'

class Empresa extends Component {
  render() {
    return (
      <div className="Empresa">
        <div className="main-container-empresa">
          <div id="logo-empresa">
            <img src={logo} alt=""/>
          </div>
          <div id="info-empresa">
            <h1>About Us</h1>
            <p>PIORICOST® is part of INDUSTRIAS EXPORTADORAS "LA MANÁ" C.A. whose corporate offices are located in Quito. D.M, Ecuador. INDUSTRIAS EXPORTADORAS "LA MANÁ" C.A. is involved in the Agro-Export and Agro-Industrial sectors, activities that include the production and commercialization of agricultural, forestry and fishing products, such as: Pitahaya, Bananas, Cocoa, Roses, Shrimp, Prawns, Tuna, Crustaceans, Mollusks and fresh fish products, for their later industrialization, with the elaboration of processed products for the most demanding markets in the world such as : USA, European Union, Russia, China, Saudi Arabia, among others, through its brands PIORICOST FRUIT®, PIORICOST FISH® AND PIORICOST ROSES®.</p>
            <div className="logos-container">
              <img src={fruit} alt=""/>
              <img src={fish} alt=""/>
              <img src={roses} alt=""/>
            </div>
            <h1>Mission</h1>
            <p>In INDUSTRIAS EXPORTADORAS "LA MANÁ" C.A. we have a firm commitment to commercialize agricultural, aquaculture and agro-industrial products of the highest quality, taking into account the needs of each of our clients and adapting to each of their requirements. We are aware that our objective is to work efficiently, to obtain the best results with our suppliers, workers, partners and above all with our clients.</p>
            <h1>Vision</h1>
            <p>To become a renowned Corporation with a global presence through our subsidiaries around the world. We are aware of the vision that the rest of the world has about our country, which is why INDUSTRIAS EXPORTADORAS "LA MANÁ" C.A. aims to change that perception of Ecuador, making our country an icon of innovation and scientific development. We will do this through scientific research (Plant Biotechnology), and its constant commitment to innovation until we become a world reference in production and marketing of agricultural, aquaculture and agro-industrial products.</p>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default Empresa;


// WEBPACK FOOTER //
// ./src/components/en-empresa/index.js